import { useEffect, useState } from 'react';
import { useStyles } from '@vp/ubik-context';
import useIsEditMode from '../../utils/useIsEditMode';
import styles, { stylesheet } from './EditWrapper.module.scss';

type EditWrapperProps = {
    url: string;
    children: React.ReactNode;
};

const EditWrapper = ({ url, children }: EditWrapperProps) => {
    const isEditMode = useIsEditMode();
    const [isClient, setIsClient] = useState(false);
    useStyles(stylesheet);

    useEffect(() => {
        setIsClient(true);
    }, []);

    if (isEditMode && isClient) {
        return (
            <a
                className={styles.link}
                onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();

                    window.open(url, '_blank');
                }}
                target="_blank"
                href={url}
                rel="noopener noreferrer"
            >
                {children}
            </a>
        );
    }

    return <>{children}</>;
};

export default EditWrapper;
